import { render, staticRenderFns } from "./QuoteFormAccount.vue?vue&type=template&id=4279fecb&scoped=true&"
import script from "./QuoteFormAccount.vue?vue&type=script&lang=ts&"
export * from "./QuoteFormAccount.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteFormAccount.vue?vue&type=style&index=0&id=4279fecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4279fecb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
